"use strict";

import angular from "angular";

import _ from "lodash";
import { Available } from "../../../gateway/Available/Available";
import { HighchartsFormatSeriesAdapter } from "../../../presentation/adpters/HighchartsFormatSeriesAdapter/HighchartsFormatSeriesAdapter";
import { HighchartsFormaterStrutureAdapter } from "../../../presentation/adpters/HighchartsFormaterStrutureAdapter/HighchartsFormaterStrutureAdapter";
import { AvailablePeriod } from "../../../presentation/services/AvailablePeriod/AvailablePeriod";
import { ColorService } from "../../../presentation/services/ColorService/ColorService";
import { FormatUnits } from "../../../presentation/services/FormatUnits/FormatUnits";
import template from "./highchart-structure.component.html";
import "./dashboard-render.service";
import "./themes/highchart-structure.component-dark.scss";
import "./themes/highchart-structure.component.scss";

("use strict");

class HighchartStructureComponent {
    constructor(
        $element,
        $filter,
        $state,
        $scope,
        $rootScope,
        ThemesService,
        DashboardRenderService
    ) {
        this.$element = $element;
        this.$state = $state;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.ThemesService = ThemesService;
        this.DashboardRenderService = DashboardRenderService;

        this.FormatUnits = new FormatUnits($filter);
        this.HighchartsFormaterStrutureAdapter = new HighchartsFormaterStrutureAdapter(
            {
                AvailablePeriod: new AvailablePeriod({
                    Available: new Available()
                }),
                FormatUnits: this.FormatUnits,
                HighchartsFormatSeriesAdapter: new HighchartsFormatSeriesAdapter(
                    {
                        ColorService: new ColorService({
                            ThemesService: this.ThemesService
                        }),
                        FormatUnits: this.FormatUnits
                    }
                )
            }
        );

        const deregisterHighchartReflow = this.$scope.$on(
            "HIGHCHART_REFLOW",
            () => {
                this.reflow();
            }
        );

        this.chartId = _.uniqueId("chart_");

        const deregisterChartCreated = this.$rootScope.$on(
            "CHART_CREATED",
            (chartId, chart) => {
                if (chartId === this.chartId) this.chart = chart;
            }
        );

        this.$scope.$on("$destroy", () => {
            deregisterHighchartReflow();
            deregisterChartCreated();
            this._destroyChart();
        });
    }

    $onInit() {
        this.renderChart(true);
    }

    $onChanges(changes) {
        this._destroyChart();
        if (
            !_.isEmpty(_.get(changes, "points.previousValue") || {}) ||
            !_.isEmpty(_.get(changes, "visualization.previousValue"))
        ) {
            this.renderChart();
        }

        if (_.get(changes, "points.previousValue") === undefined) {
            this.renderChart();
        }
    }

    _getStructure() {
        return this.HighchartsFormaterStrutureAdapter.getStructure({
            companyId: this.$state.params.id,
            structure: this.visualization.chart,
            series: this.series,
            points: this.points,
            filters: this.filters,
            currentComparation: this.currentComparation,
            options: {
                projection: this.projection,
                budget: this.budget,
                goals: this.goals,
                highlightsSeries: this.highlightsSeries
            }
        });
    }

    renderChart(timeout) {
        try {
            if (!_.get(this.visualization, "chart")) return;
            const structure = this.customStructure
                ? this.visualization.chart
                : this._getStructure();

            if (!structure) return;
            const element = this.$element[0].getElementsByClassName(
                "highchart-structure_chart-wrapper"
            );
            if (!structure.chart)
                structure.chart = {
                    renderTo: element[0]
                };
            else structure.chart.renderTo = element[0];
            this.DashboardRenderService.registerVisualizationStructuresToBeRender(
                this.chartId,
                structure,
                !timeout
            );
        } catch (ex) {
            console.error("ex", ex);
        }
    }

    reflow() {
        if (this.chart) {
            const width = this.chart.renderTo.clientWidth;
            const height = this.chart.renderTo.clientHeight;
            this.chart.setSize(width, height, true);
        }
    }

    _destroyChart() {
        try {
            this.chart && this.chart.destroy();
        } catch (ex) {
            // por algum motivo esta dando throw nas visualizations da carteira
        }
    }
}

export { HighchartStructureComponent };

HighchartStructureComponent.$inject = [
    "$element",
    "$filter",
    "$state",
    "$scope",
    "$rootScope",
    "ThemesService",
    "DashboardRenderService"
];

const name = "highchartStructureComponent";
const def = {
    bindings: {
        visualization: "<",
        series: "<",
        points: "<",
        filters: "<",
        currentComparation: "<",
        customStructure: "<",
        projection: "<",
        goals: "<",
        budget: "<",
        hold: "<",
        highlightsSeries: "<"
    },
    controller: HighchartStructureComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
